<div class="vision-mission" [ngClass]="(borderTop == true)?'lane-top':'no-border'">
    <div class="row">
        <div class="col-md-6">
            <div class="vision h-100 py-5 px-md-4 px-3">
                <h4 class="title">{{ dataVisi?.title }}</h4>
                <div class="list-circle no-list" [innerHTML]="dataVisi?.content"></div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="mission h-100 py-5 pr-md-4">
                <h4 class="title">{{ dataMisi?.title }}</h4>
                <div class="list-circle no-list" [innerHTML]="dataMisi?.content"></div>
            </div>
        </div>
    </div>
</div>
